import React from 'react';
import './projects.css';


const ProjectsCard = ({ photo, title, url, year, body, git, tech }) => {

let techArray = tech.split(", ");

	return (
		<div 
			className='card-style'
			style={{ display: 'flex', flexDirection: 'column', width: '350px' }}
		>
			<div style={{ alignSelf: 'center' }}>
				<img className='head-image' src={photo} alt='Project'/>
			</div>
			<div>
				<div>
					<div className='flex-display gap'>
						<h1>{title}</h1>
					</div>
						
						<p className='year'>Year: {year}</p>
						<p>{body}</p>
				</div>
				<div className='link-container'>
				  {git && <a className='link' href={git} target="_blank" rel="noopener noreferrer">GitHub Repository</a>}
				  {git && url && ' | '}
				  {url && <a className='link' href={url} target="_blank" rel="noopener noreferrer">Live Demo</a>}
				</div>
				<div className='flex-display wrap'>
			      {techArray.map((techItem, index) => (
			            <div key={index} className='tech-item'>
			              <p className='button-blue'>{techItem}</p>
			            </div>
			          ))}
				</div>
			</div>
		</div>

	)
}

export default ProjectsCard;